import { render, staticRenderFns } from "./PopularAd.vue?vue&type=template&id=048343fe"
import script from "./PopularAd.vue?vue&type=script&lang=js"
export * from "./PopularAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports